export default "__VITE_ASSET__Cl9oeeRS__"